import * as React from 'react';

import CampaignAchievementsItem from './CampaignAchievementsItem';

const CampaignAchievementsDefaultItems = (): JSX.Element => (
  <React.Fragment>
    <CampaignAchievementsItem
      key="campaign-achievements-campaign"
      type="campaign"
      showDefault
    />
    <CampaignAchievementsItem
      key="campaign-achievements-content-creator"
      type="content_creator"
      showDefault
    />
    <CampaignAchievementsItem
      key="campaign-achievements-post"
      type="post"
      showDefault
    />
  </React.Fragment>
);

export default CampaignAchievementsDefaultItems;
